module.exports = __webpack_public_path__ + "img/icon-4.825a8b3e.png";